<div class="server-monitoring-container" loading-spin [isLoading]="reloading" [loadingSize]="'big'">
    <div *ngFor="let item of config"
        [ngClass]="{'properties': item.id ==='properties', 'memory': item.id ==='memory', 'threads':item.id ==='threads'}">
        <div class="row-title">
            <span class="title">{{item.name}}</span><span *ngIf="item.id ==='threads'">({{threadCount}} threads
                are currently running.)</span>
        </div>
        <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-balham" [columnDefs]="item.columnDefs"
            [rowData]="item.rowData" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>
</div>